
import Vue from "vue";
import {SaleLayoutLogo} from "@/utils/sale-layouts/logo";
import AppFieldConditionEdit from "../models/ConditionEdit.vue";
import { Condition } from "@/utils/condition/condition";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleInSaleLayoutPropSelectGroup } from "@/utils/prop-select/sale-in-sale-layout-prop-group";

export default Vue.extend({
	data(){
		return {
			HideOnPdfOnPrint: false,
			HideOnPdfOnEmailSend: false,
			HideOnPdfOnDownload: false,
			hiddenKeys: [] as string[],
		};
	},
	props: {
		value: {
			type: Object as ()=>SaleLayoutLogo,
			required: true
		}
	},
	computed: {
		conditionProps():PropSelectGroup{
			return getSaleInSaleLayoutPropSelectGroup();
		}
	},
	watch: {
		logo: {
			immediate: true,
			handler(){
				this.HideOnPdfOnPrint = this.value.HideOnPdfOnPrint;
				this.HideOnPdfOnEmailSend = this.value.HideOnPdfOnEmailSend;
				this.HideOnPdfOnDownload = this.value.HideOnPdfOnDownload;
			}
		}
	},
	methods: {
		submit(){
			this.value.HideOnPdfOnPrint = this.HideOnPdfOnPrint;
			this.value.HideOnPdfOnEmailSend = this.HideOnPdfOnEmailSend;
			this.value.HideOnPdfOnDownload = this.HideOnPdfOnDownload;
			this.close();
		},
		close(){
			this.$emit("close");
		},
		async addCondition(){
			let condition = new Condition();
			this.hiddenKeys.push(condition.key);
			this.value.Conditions.push(condition);
			await this.$nextTick();
			this.hiddenKeys.pop();
		},
		removeCondition(i:number){
			this.value.Conditions.splice(i,1);
		},
		shouldShowKey(key:string):boolean{
			return this.hiddenKeys.indexOf(key) == -1;
		}
	},
	components: {
		AppFieldConditionEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
